import { render, staticRenderFns } from "./InsurerSubmissionPage.vue?vue&type=template&id=5a4f9493&scoped=true"
import script from "./InsurerSubmissionPage.vue?vue&type=script&lang=js"
export * from "./InsurerSubmissionPage.vue?vue&type=script&lang=js"
import style0 from "./InsurerSubmissionPage.vue?vue&type=style&index=0&id=5a4f9493&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4f9493",
  null
  
)

export default component.exports